import React from 'react';

const tariffTypeLanding = (props) => {
    return (
        <div className="col-auto">
            <div className="tariff-type">
                {props.tt.tariffType.name}
            </div>
            <div className={`tariff-model ${props.selectedMunicipality ? 'enabled' : 'disabled'}`}>
                {props.tt.tariffModels.map(tm => {
                    return (<span onClick={() => props.selectTariffModel(tm.id)}>
                        {props.tariffModelShortNames && props.tariffModelShortNames[tm.id] ? props.tariffModelShortNames[tm.id] : tm.name}
                    </span>)
                })}
            </div>
        </div>
    );
};

export default tariffTypeLanding;
